import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const ManagerialReportsPage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/reports/managerial/invoicing`);
    }
  }, [match]);

  return null;
};

export default ManagerialReportsPage;
